
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-marketing",
      function () {
        return require("private-next-pages/content-marketing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-marketing"])
      });
    }
  